import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Clear from '@material-ui/icons/Clear';
import Remove from '@material-ui/icons/Remove';
import RemoveCircle from '@material-ui/icons/RemoveCircle';
import TripOrigin from '@material-ui/icons/TripOrigin';
import Warning from '@material-ui/icons/Warning';
import { ReactComponent as SpTag } from '../../../assets/dmarc-sp-icon.svg';

import {
    DMARC_NONE,
    DMARC_STATUS_POLICY_INVALID,
    DMARC_STATUS_POLICY_NONE,
    DMARC_STATUS_POLICY_QUARANTINE,
    DMARC_STATUS_POLICY_REJECT,
    DMARC_QUARANTINE,
    DMARC_REJECT,
    DMARC_STATUS_INVALID,
    DMARC_STATUS_NO_RECORD,
} from './dmarc-policy-values';

// Width
export const RIGHT_PANE_WIDTH = 450;
export const SIDE_NAV_WIDTH = 56;

// Canvas Section
export const REACT_GRID_LAYOUT = Object.freeze( { lg: 2, md: 2, sm: 2, xs: 1, xxs: 1 } );
export const REACT_GRID_BREAKPOINTS = Object.freeze( { lg: 1920, md: 1280, sm: 960, xs: 600, xxs: 0 } );
export const REACT_GRID_ROW_HEIGHT = 45;
export const CANVAS_WIDGET_MARGINS = [16,16];
export const CANVAS_CARD_HEADER_HEIGHT = 108;

export const iconMap = Object.freeze( {
    [DMARC_NONE]: { icon: TripOrigin, tooltip: 'p=none' },
    [DMARC_QUARANTINE]: { icon: Warning, tooltip: 'p=quarantine' },
    [DMARC_REJECT]: { icon: RemoveCircle, tooltip: 'p=reject' },
    [DMARC_STATUS_INVALID]: { icon: Clear, tooltip: 'invalid record' },
    [DMARC_STATUS_NO_RECORD]: { icon: Remove, tooltip: 'no record' },
    [DMARC_STATUS_POLICY_INVALID]: { icon: Clear, tooltip: 'invalid record' },
    [DMARC_STATUS_POLICY_NONE]: { icon: TripOrigin, tooltip: 'p=none' },
    [DMARC_STATUS_POLICY_QUARANTINE]: { icon: Warning, tooltip: 'p=quarantine' },
    [DMARC_STATUS_POLICY_REJECT]: { icon: RemoveCircle, tooltip: 'p=reject' },
    'null': { icon: Remove, tooltip: 'no record' },
    policyInherited: { icon: ArrowDownward, tooltip: 'inherited' },
    subdomainPolicy: { icon: SpTag, tooltip: 'sp= of parent domain' },
} );

// Side Nav Items
export const REPORTS_NAV_ITEM = Object.freeze( {
    icon: 'barChart',
    id: 'reports',
    label: 'Reporting',
    order: 2,
    url: '/reports'
} );

//Snackbar
export const SNACKBAR_TYPES = Object.freeze( {
    error: 'generalError',
    success: 'generalSuccess',
} );
